import { Component } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { AuthService } from '../services/auth.service';
import { FirebaseService } from '../services/firebase.service';
import { NewTaskModalPage } from '../new-task-modal/new-task-modal';
import { SearchPage } from '../search/search';
import { ProfilePage } from '../profile/profile';
import { DetailsPage } from '../details/details';
import { LoginPage } from '../login/login';


@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html'
})

export class MenuPage {

  items: Array<any>;

  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private authService: AuthService,
    private firebaseService: FirebaseService
    //private ideas: IdeasProvider
  ) {}

  ionViewWillEnter(){
    this.getData();
  }

  getData(){
    this.firebaseService.getMyIdeas()
    .then(ideas => {
      this.items = ideas;
    })
  }

  viewDetails(id, item){
    let data = {
      categorie: item.categorie,
      title: item.title,
      description: item.description,
      url: item.url,
      town: item.town,
      image: item.image,
      id: id
    }
    this.navCtrl.push(DetailsPage, {
      data: data
    })
  }

  openNewUserModal(){
    let modal = this.modalCtrl.create(NewTaskModalPage);
    modal.onDidDismiss(data => {
      this.getData();
    });
    modal.present();
  }

  goToSearch(){
    this.navCtrl.push(SearchPage);
  }

  goToProfile(){
    this.navCtrl.push(ProfilePage);
  }


  logout(){
    this.firebaseService.unsubscribeOnLogOut();
    this.authService.doLogout()
    .then(res => {
      this.navCtrl.push(LoginPage);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts